import React, { Component } from 'react'
import PropTypes from 'prop-types'
import EditCarrierForm from './forms/EditCarrierForm'
import { Anchor } from './common/Anchor'
import FormHeader from './common/FormHeader'
import { updateCarrierAction } from '../actions/carriersActions'

class EditCarrier extends Component {
  static propTypes = {
    carrier: PropTypes.object.isRequired,
    getCarrier: PropTypes.func.isRequired,
    isCarrierLoading: PropTypes.bool,
    match: PropTypes.object,
  }

  componentDidMount() {
    const { getCarrier, match } = this.props
    getCarrier(match.params.id)
  }

  render() {
    const { carrier, isCarrierLoading } = this.props
    const crumbs = [
      <Anchor to="/inventory/all">Inventory</Anchor>,
      <Anchor to="/inventory/all/carriers">Carriers</Anchor>,
      'Edit Carrier',
    ]

    return (
      <section className="EditCarrier">
        <FormHeader crumbs={crumbs} />
        <EditCarrierForm
          submitAction={updateCarrierAction}
          initialValues={carrier}
          isCarrierLoading={isCarrierLoading}
          enableReinitialize
        />
      </section>
    )
  }
}

export default EditCarrier
